<template>
  <v-bottom-navigation
    mandatory
    grow
    color="teal-darken-2"
    elevation="4"
    class="footer-nav"
  >
    <v-btn :to="{ name: 'home' }">
      <v-icon>mdi-home-account</v-icon>
      <span>工作台</span>
    </v-btn>

    <v-btn :to="{ name: 'overview' }">
      <v-icon>mdi-account-clock</v-icon>
      <span>打卡</span>
    </v-btn>

    <v-btn :to="{ name: 'calender' }">
      <v-icon>mdi-calendar-month</v-icon>
      <span>统计</span>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
export default {
  name: "Footerbar",
};
</script>

<style scoped>
.footer-nav {
  position: fixed !important;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: calc(56px + env(safe-area-inset-bottom, 0px)) !important;
  padding-bottom: env(safe-area-inset-bottom, 0px) !important;
  box-sizing: border-box !important;
  background-color: #ffffff !important;
}

.footer-nav :deep(.v-bottom-navigation__content) {
  height: 56px !important;
}
</style>
